/* eslint-disable no-magic-numbers */
/* eslint-disable complexity */
import React, { useState, useEffect } from "react";
import CarouselBottomArrow from "../../shared/carousel-bottom-arrow";
import { DEFAULT_MOBILE_SLIDER_SETTINGS, NUMBER } from "../../../constants/app-constants";
import styles from "./styles.css";
import PropTypes from "prop-types";
import Rating from "../../shared/react-rating-wrapper";
import IconStar from "../../shared/icon-star";
import { getParticularDay, getMonth } from "../../../utils/helpers/get-day-from-date";
import { Text } from "@cars24/turbo-web/lib/text";
import ReviewSchema from "../../shared/review-schema";
import { Button } from "@cars24/turbo-web/lib/button";
import ArrowRight from "./images/arrow-right.svg";
import { appUrl } from "../../../constants/url-constants";
import { Modal } from "@cars24/turbo-web/lib/modal";
import ReviewForm from "../review-form";
import EditIcon from "./images/edit-icon.svg";

const CustomerReviewCard = ({
    isSSR,
    list,
    showImg = true,
    getCustomerReviewsConnect,
    minLength = NUMBER.ZERO,
    showDate = true,
    average,
    total
}) => {
    const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);

    useEffect(() => {
        if (!isSSR) {
            const payload = {
                expand: "customer_review_list",
                page: 0,
                size: 10
            };
            getCustomerReviewsConnect(payload);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSSR]);

    const handleWriteReview = () => {
        setIsBottomSheetOpen(true);
    };

    return (
        list.length > minLength &&
        <div styleName={"styles.testimonialWrap"}>
            <Text
                align="left"
                as="h2"
                fontWeight="semibold"
                size="450"
                transform="none"
            >
            User Reviews & Ratings
            </Text>
            <div styleName={"styles.writeRatting"}>
                <div>
                    {
                        average && <div styleName={"styles.rating"}>
                            <div styleName={"styles.rattingWrapper"}>
                                <Rating
                                    readonly
                                    initialRating={average}
                                    emptySymbol={<IconStar type={"empty"} />}
                                    fullSymbol={<IconStar type={"fill"} />} />
                            </div>
                            <Text
                                align="left"
                                as="p"
                                fontWeight="medium"
                                size="300"
                                transform="none"
                            >
                                {`${average} out of 5 (${total} ratings)`}
                            </Text>
                        </div>
                    }
                </div>
                <Button suffixIcon={<img src={EditIcon} alt="edit icon"/>} variant="tertiary" size="large" type="button" label={"Write a review"} onClick={handleWriteReview} />
            </div>
            <div styleName={"styles.carouselWrap"} >
                <CarouselBottomArrow
                    settings={{ ...DEFAULT_MOBILE_SLIDER_SETTINGS, slidesToShow: 3, slidesToScroll: 3 }}
                >
                    {
                        list.map((item, index) => (
                            <div styleName={"styles.testimonialCard"} key={index}>
                                {showImg && <div styleName={"styles.customerImg"}>
                                    <img src={item.imgUrl} alt="customer" />
                                </div>}
                                <div styleName={"styles.customerInfoMainWrapper"}>
                                    <div styleName={"styles.customerReview"}>
                                        {
                                            item.review_rating && <div styleName={"styles.rattingWrapper"}>
                                                <Rating
                                                    readonly
                                                    initialRating={parseInt(item.review_rating)}
                                                    emptySymbol={<IconStar type={"empty"} />}
                                                    fullSymbol={<IconStar type={"fill"} />}
                                                />
                                            </div>
                                        }
                                        {
                                            showDate &&
                                            <span styleName={"styles.date"}>
                                                {
                                                    (item.testimonialDate || item.created_at) &&
                                                    `
                                                        ${getParticularDay(new Date(item.testimonialDate || item.created_at))}
                                                        ${getMonth(new Date(item.testimonialDate || item.created_at), true)},
                                                        ${new Date(item.testimonialDate || item.created_at).getFullYear()}
                                                    `
                                                }
                                            </span>
                                        }
                                    </div>
                                    {
                                        (item.testimonialTitle || item.title) &&
                                        <h3>{`${item.testimonialTitle || item.title}`}</h3>
                                    }
                                    <p>{item.message || item.review_description}</p>
                                    <div styleName={"styles.nameBottomWrapper"}>
                                        <p>{item.fullName || item.customer_name}</p>
                                        <p styleName="modelName">
                                            Sold {item.makeName || item.make} {item.modelName || item.model}, {item.cityName || item.city}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </CarouselBottomArrow>
                <div styleName="styles.buttonWrapper">
                    <a href={`${appUrl()}/used-car-valuation/customer-reviews/?page=1`}>
                        <Button variant="secondary" size="medium" type="button" label={"See all reviews"} suffixIcon={<img src={ArrowRight} alt="right-arrow"/>} />
                    </a>
                </div>

                {isSSR && <ReviewSchema reviews={list} averageRating={average} totalReviews={total} />}
            </div>
            {
                isBottomSheetOpen &&
                <Modal
                    width="fit-content"
                    height="fit-content"
                    isOpen
                    onClose={() => setIsBottomSheetOpen(false)}
                >
                    <ReviewForm />
                </Modal>
            }
        </div>
    );
};

CustomerReviewCard.propTypes = {
    isSSR: PropTypes.bool,
    list: PropTypes.array,
    getCustomerReviewsConnect: PropTypes.func,
    showImg: PropTypes.bool,
    minLength: PropTypes.number,
    showDate: PropTypes.bool,
    average: PropTypes.number,
    total: PropTypes.number
};

export default CustomerReviewCard;
